"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var PanelBase_1 = require("./PanelBase");
var monitoring_1 = require("../../services/monitoring");
var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            root: null
        };
        _this.handleDocumentEventListeners = function (props) {
            if (props.open) {
                document.addEventListener('click', _this.handleDocumentClick, false);
            }
            else {
                document.removeEventListener('click', _this.handleDocumentClick);
            }
        };
        _this.handleDocumentClick = function (event) {
            var node = _this.state.root;
            // If event, and node doesn't contain the srcElement
            if (event && node && !node.contains(event.srcElement)) {
                _this.props.onClose(); // onClose event callback
            }
        };
        return _this;
    }
    Panel.prototype.componentDidMount = function () {
        monitoring_1.default('panel');
    };
    Panel.prototype.componentWillReceiveProps = function (newProps) {
        this.handleDocumentEventListeners(newProps);
        if (newProps.open) {
            this.setState({ hasOpened: true });
        }
    };
    Panel.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleDocumentClick);
    };
    Panel.prototype.render = function () {
        var _a = this.props, className = _a.className, open = _a.open;
        var classes = classNames('panel', className, {
            'panel--current': open
        });
        return React.createElement(PanelBase_1.default, __assign({ type: "panel" }, this.props, { className: classes }));
    };
    return Panel;
}(React.Component));
exports.default = Panel;
//# sourceMappingURL=Panel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Panel/Panel.js
// module id = 260
// module chunks = 0